import { component } from 'picoapp';

export default component(async (node) => {
  const scrollIndicator = node.querySelector('[data-scroll-indicator]');
  const exploreButton = node.querySelector('[data-explore-button');
  const videos = node.querySelectorAll('[data-banner-media] video');

  const startAnimation = (event) => {
    const isMobileVideo = event?.currentTarget?.matches('.hidden');

    if (window.theme.isMobile === isMobileVideo || !event) {
      document.addEventListener(
        'readystatechange',
        () => document.readyState === 'complete' && node.setAttribute('open', ''),
      );
    }
  };

  if (node.matches('[active]') && videos.length) {
    Array.from(videos).every((video) => {
      const isMobileVideo = video.matches('.hidden');

      if (window.theme.isMobile === isMobileVideo && !video.paused) {
        startAnimation();
        return false;
      }

      video.addEventListener('canplaythrough', startAnimation);
      return true;
    });
  } else if (node.matches('[active]')) {
    startAnimation();
  }

  const initScrollIndicator = () => {
    const target = node.closest('section').nextElementSibling;

    if (target) {
      scrollIndicator.addEventListener('click', (event) => {
        event.preventDefault();

        target.scrollIntoView({ behavior: 'smooth' });
      });
    }
  };

  const initExploreButton = () => {
    exploreButton.addEventListener('click', () => {
      window.scrollTo({ left: 0, top: node.offsetHeight + node.offsetTop, behavior: 'smooth' });
    });
  };

  if (scrollIndicator) {
    initScrollIndicator();
  }

  if (exploreButton) {
    initExploreButton();
  }
});
